module.exports = __webpack_public_path__ + "img/DDF Software.2619ed02.jpg";